/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateAuthLogout } from '../../axios/candidateAuthLogout'
import type { CandidateAuthLogoutError, CandidateAuthLogoutResponse } from '../../types/CandidateAuthLogout'

export const candidateAuthLogoutMutationKey = () => [{ url: '/candidate-center/logout' }] as const

export type CandidateAuthLogoutMutationKey = ReturnType<typeof candidateAuthLogoutMutationKey>

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateAuthController.php CandidateAuthController::logout */
export function useCandidateAuthLogout<TContext = unknown>(
	options?: UseMutationOptions<CandidateAuthLogoutResponse, AxiosError<CandidateAuthLogoutError>, void, TContext>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateAuthLogoutMutationKey(),
		mutationFn: () => candidateAuthLogout(config).then(res => res.data),
		...options,
	})
}
